import React, { memo, useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Row, Col } from "reactstrap";
import logo from "../../../Assets/Images/logo.png";
import moment from "moment";
import AmenitiesAnalysis from "../MarketAnalysisPDF/AmenitiesAnalysisPdf/AmenitiesAnalysisPdf";
import CampClassification from "../MarketAnalysisPDF/CampClassificationPdf/CampClassificationPdf";
import PricingAnalysisPdf from "../MarketAnalysisPDF/PricingAnalysisPdf/PricingAnalysisPdf";
import MarketSummaryPdf from "../MarketAnalysisPDF/MarketSummaryPdf/MarketSummaryPdf";
import PdfMap from "../MarketAnalysisPDF/PdfMap/PdfMap";
import RVParkList from "../MarketAnalysisPDF/RVParkList/RVParkList";
import ActivityPdf from "../MarketAnalysisPDF/ActivityPdf/ActivityPdf";
import { SeasonalityPdf } from "../Index";
import { developmentSeperation, splitDevelopmentData, transactionSeperation, getImageSrc } from "../../../helpers/dataHelper";
import PDFKnownDevelopment from "../PDFComponents/PDFKnownDevelopment";
import PDFTransaction from "../PDFComponents/PDFTransaction";
import ConstantData from "../../../Utils/Constant";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";


const totalAmenitiesCount = ConstantData.totalAmenitiesCount;
let elements, element;
let count = 0;
const applyToArray = (func, array) => func.apply(Math, array);
let campSpotRows;
let campSpotTableRow;
let pricingTableRow;
let pricigRows;
let profileArray = [];
let priceAnalysis = [];
let seasonalityRows;
let seasonalityTableRow;
let amenitiesRows;
let amenitiesTableRow;
let splittedArray;
let amenitiesData = [];
let seasonalityPg = 0,
  pricingPg = 0,
  campSpotPg = 0,
  rvListPg = 0,
  amenitiesPg = 0,
  activityPg = 0,
  developPg = 0,
  transactionPg = 0;
let pageIndex = [];

const DownloadDetailReport = memo((props) => {
  let date = new Date();
  const [reportData, setReportData] = useState({
    amenitiesAnalysis: [],
    campingSpotClassifications: [],
    pricingAnalysis: [],
    seasonalityAnalysis: [],
    marketAnalysis: [],
    userMarket: {},
    marketPois: [],
    rvParkList: [],
    graphData: [],
    activities: [],
    developmentState: [],
    transactionState: []
  });
  const [showUserLogo, setShowUserLogo] = useState(null);
  const displayLogoRef = useRef(logo);

  const noDataOfKnownData = useRef();
  const { id, key } = useParams();
  const navigate = useNavigate();
  let pageNo = 2;
  let calculatePage = [];
  const marketIdValue = id;
  const [companyInfo, setCompanyInfo] = useState({
    companyName: 'RVParkIQ',
    companyURL: "https://rvparkiq.com",
  })
  //get detail reports
  useEffect(() => {
    getUserLogo();
    getReportDetails();
  }, []);

  const getUserLogo = () => {
    let sKey = !key ? null : key;
    apiCommonTrigger("get" , Config.API_URL + "/markets/userlogo/" , [sKey])
    .then((res) => {
      if (res.status === 200) {
        const logoData = getImageSrc(res.data.userlogoblob);
        displayLogoRef.current = logoData || logo;
        setShowUserLogo(logoData);
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  const printPdfFull = (
    data,
    address,
    amenitiesData,
    value,
    id,
    name,
    avgPrice
  ) => {
    let pageBreak;

    if (id !== "1" && id !== "4" && id !== "5" && id !== "6" && id !== "8" && id != "9") {
      count += data.length;
    }
    if (id === "1") {
      let rowsAvailable = data.length + 3;
      count += rowsAvailable;
      pageBreak = count > 17;
    } else if (id === "2") {
      count += 4;
      pageBreak = count > 10;
    } else if (id === "3") {
      count += 5;
      pageBreak = count > 17;
    } else if (id === "4") {
      let campSpotRows = data.length * 3 + 3;
      count += campSpotRows;
      pageBreak = count > 17;
    } else if (id === "5") {
      count += 6;
      pageBreak = count > 17;
    } else if (id === "6") {
      let sesRows = data.length * 3 + 3;
      count += sesRows;
      pageBreak = count > 17;
    } else if (id === "8") {
      let activityRows = data.length * 3 + 3;
      count += activityRows;
      pageBreak = count > 22;
    } else if (id == "9") {
      count += 20;
      pageBreak = true;
    } else if (id == "10") {
      count += 20;
      pageBreak = true;
    }

    pageNo = pageNo + 1;
    calculatePage.push({
      id: id,
      count: count,
      name: name,
    });
    if (pageIndex.indexOf(id) === -1) {
      pageIndex.push(id);
      if (id === "5") {
        seasonalityPg = pageNo;
      } else if (id === "3") {
        campSpotPg = pageNo;
      } else if (id === "4") {
        pricingPg = pageNo;
      } else if (id === "2") {
        amenitiesPg = pageNo;
      } else if (id === "1") {
        rvListPg = pageNo;
      } else if (id === "8") {
        activityPg = pageNo;
      } else if (id === "9") {
        developPg = pageNo;
      } else if (id === "10") {
        transactionPg = pageNo;
      }
    }
    if (pageBreak) {
      elements.push(
        <>
          <section className={!showUserLogo ? "pdf-wid-wrapper with_our_logo" : "pdf-wid-wrapper with_client_logo"}>
            <header className="page-header">
              <div className="page-logo">
                <a href="#">
                  <img src={displayLogoRef.current} alt="RVParkIQ" />
                </a>
              </div>
              <div className="header-address">
                <p>{address}</p>
              </div>
              <div className="clear"></div>
            </header>
            <div className="page-number">Page No: {pageNo}</div>
            <div className="page-body">
              <h4 className="pdf-title">{name}</h4>
              {id === "2" ? (
                <AmenitiesAnalysis
                  data={data}
                  amenitiesData={amenitiesData}
                  value={value}
                  showLegend={true}
                  key={value}
                />
              ) : id === "1" ? (
                <RVParkList key={value} data={data} />
              ) : id === "3" ? (
                <CampClassification data={data} />
              ) : id === "4" ? (
                <PricingAnalysisPdf data={data} avgPrice={avgPrice} />
              ) : id === "5" || id === "6" ? (
                <SeasonalityPdf value={value} data={data} />
              ) : id === "8" ? (
                <ActivityPdf keys={value} data={data} />
              ) : id === "9" ? (
                data.map((kdFDt) => (
                  <>
                    <PDFKnownDevelopment
                      key={kdFDt.id}
                      noDataOfKnownData={noDataOfKnownData.current}
                      MarketId={!parseInt(marketIdValue) ? null : parseInt(marketIdValue)}
                      knowndata={kdFDt.data}
                      kdDataCount={kdFDt.kdCount}
                      kdTableDataSize={kdFDt.tableSize}
                      isIndividualDevelopment={true}
                    />
                  </>
                ))
              ) : id === "10" ? (
                data.map((strFormatData) => (
                  <>
                    <PDFTransaction
                      storeDetails={strFormatData.storeDetails}
                      transactionData={strFormatData.data}
                      transactionAttrData={strFormatData.attrData}
                    />
                  </>
                ))
              ) : (
                ""
              )}
            </div>
          </section>
          {pageBreak ? <div id="pbreak" className="page-break" /> : ""}
        </>
      );
    } else {
      element.push(
        <>
          <header className={!showUserLogo ? "page-header with_our_logo" : "page-header with_client_logo"}>
            <div className="page-logo">
              <a href="#">
                <img src={displayLogoRef.current} alt="RVParkIQ" />
              </a>
            </div>
            <div className="header-address">
              <p>{address}</p>
            </div>
            <div className="clear"></div>
          </header>
          <div className="page-number">Page No: {pageNo}</div>
          <div className="page-body">
            <h4 className="pdf-title">{name}</h4>
            {id === "2" ? (
              <AmenitiesAnalysis
                data={data}
                amenitiesData={amenitiesData}
                value={value}
                showLegend={true}
                key={value}
              />
            ) : id === "1" ? (
              <RVParkList key={value} data={data} />
            ) : id === "3" ? (
              <CampClassification data={data} />
            ) : id === "4" ? (
              <PricingAnalysisPdf data={data} avgPrice={avgPrice} />
            ) : id === "5" || id === "6" ? (
              <SeasonalityPdf value={value} data={data} />
            ) : id === "8" ? (
              <ActivityPdf value={value} data={data} />
            ) : id === "9" ? (
              data.map((kdFDt) => (
                <>
                  <PDFKnownDevelopment
                    noDataOfKnownData={noDataOfKnownData.current}
                    MarketId={!parseInt(marketIdValue) ? null : parseInt(marketIdValue)}
                    knowndata={kdFDt.data}
                    kdDataCount={kdFDt.kdCount}
                    kdTableDataSize={kdFDt.tableSize}
                    isIndividualDevelopment={true}
                  />
                </>
              ))
            ) : id === "10" ? (
              data.map((strFormatData) => (
                <>
                  <PDFTransaction
                    storeDetails={strFormatData.storeDetails}
                    transactionData={strFormatData.data}
                    transactionAttrData={strFormatData.attrData}
                  />
                </>
              ))
            ) : (
              ""
            )}
          </div>
        </>
      );
    }
    count = pageBreak ? 0 : count;
    // }
  };

  const printPdfPartial = (
    data,
    address,
    amenitiesData,
    value,
    id,
    name,
    avgPrice
  ) => {
    let pageBreaks;
    if (id !== "1" && id !== "4" && id !== "5" && id !== "6" && id !== "8" && id != "9") {
      count += data.length;
    }

    if (id === "1") {
      let rowsAvailable = data.length + 3;
      count += rowsAvailable;
      pageBreaks = count > 17;
    } else if (id === "2") {
      count += 4;
      pageBreaks = count > 10;
    } else if (id === "3") {
      count += 5;
      pageBreaks = count > 17;
    } else if (id === "4") {
      let campSpotRows = data.length * 3 + 3;
      count += campSpotRows;
      pageBreaks = count > 17;
    } else if (id === "5") {
      count += 6;
      pageBreaks = count > 17;
    } else if (id === "6") {
      let sesRows = data.length * 3 + 3;
      count += sesRows;
      pageBreaks = count > 17;
    } else if (id === "8") {
      let activityRows = data.length * 3 + 3;
      count += activityRows;
      pageBreaks = count > 22;
    } else if (id == "9") {
      count += 20;
      pageBreaks = data.length > 1;
    }
    let showHeader =
      calculatePage[calculatePage.length - 1].name === name ? false : true;
    calculatePage.push({
      id: id,
      count: count,
      name: name,
    });
    if (pageIndex.indexOf(id) === -1) {
      pageIndex.push(id);
      if (id === "5") {
        seasonalityPg = pageNo;
      } else if (id === "3") {
        campSpotPg = pageNo;
      } else if (id === "4") {
        pricingPg = pageNo;
      } else if (id === "2") {
        amenitiesPg = pageNo;
      } else if (id === "1") {
        rvListPg = pageNo;
      } else if (id === "8") {
        activityPg = pageNo;
      } else if (id === "9") {
        developPg = pageNo;
      }
    }
    element.push(
      <>
        {/* <section className="pdf-wid-wrapper"> */}
        <div className="page-number">.</div>
        <div className="page-body">
          {showHeader ? <h4 className="pdf-title">{name}</h4> : ""}
          {id === "2" ? (
            <AmenitiesAnalysis
              data={data}
              amenitiesData={amenitiesData}
              value={value}
              showLegend={showHeader}
              key={value}
            />
          ) : id === "1" ? (
            <RVParkList key={value} data={data} />
          ) : id === "3" ? (
            <CampClassification data={data} />
          ) : id === "4" ? (
            <PricingAnalysisPdf data={data} avgPrice={avgPrice} />
          ) : id === "5" || id === "6" ? (
            <SeasonalityPdf value={value} data={data} />
          ) : id === "8" ? (
            <ActivityPdf keys={value} data={data} />
          ) : id === "9" ? (
            data.map((kdFDt) => (
              <PDFKnownDevelopment
                key={kdFDt.id}
                noDataOfKnownData={noDataOfKnownData.current}
                MarketId={!parseInt(marketIdValue) ? null : parseInt(marketIdValue)}
                knowndata={kdFDt.data}
                kdDataCount={kdFDt.kdCount}
                kdTableDataSize={kdFDt.tableSize}
                isIndividualDevelopment={true}
              />
            ))
          ) : (
            ""
          )}
        </div>
        {/* </section> */}
        {/* {pageBreaks ? <div id="pbreak" className="page-break" /> : ""} */}
      </>
    );
    count = pageBreaks ? 0 : count;
    // }
    if (count === 0) {
      pushElement();
    }
  };

  //combine components having less data and push to print under single page
  const pushElement = () => {
    elements.push(
      <>
        <section className="pdf-wid-wrapper">{element}</section>
        <div id="pbreak" className="page-break" />
      </>
    );
    element = [];
  };

  //get report info
  const getReportDetails = () => {
    apiCommonTrigger("post",`${Config.API_URL}/markets/market/report/detaildata`, {
        marketId: !parseInt(id) ? null : parseInt(id),
        securityKey: !key ? null : key,
      }).then((res) => {
      if (res.status === 200) {
        elements = [];
        element = [];
        pageIndex = [];
        pageNo = 2;
        calculatePage = [];
        count = 0;
        amenitiesData = res.data.amenityAnalysis;
        const widgetDataValue = developmentSeperation(res.data.knownDevelopmentData, null, null, null, true);
        noDataOfKnownData.current = widgetDataValue.noDataOfKnownData;
        const developmentResult = splitDevelopmentData(widgetDataValue.widgetData);

        const salesTransactionDataResult = { data: res.data.salesTransactionData, status: 200 }
        const resData = transactionSeperation(salesTransactionDataResult);
        const transactionDataValue = resData.transFormatData;
        const transNoDataDataValue = resData.transNoData;

        let transData = transNoDataDataValue ? [] : transactionDataValue;


        if (developmentResult.length) {
          developmentResult.forEach((devData) => {
            if (devData.length) {
              printPdfFull(
                devData,
                res.data.userMarket.address,
                "",
                "",
                "9",
                "Development",
              );
            }
          });
        }


        if (transData.length) {
          transData.forEach((strData) => {
            if (strData.length) {
              printPdfFull(
                strData,
                res.data.userMarket.address,
                "",
                "",
                "10",
                "Transaction",
              );
            }
          });
        }


        if (
          res.data.rvParksList &&
          res.data.rvParksList.rvparks &&
          res.data.rvParksList.rvparks.length > 0
        ) {
          const rvListData = [];
          const csize = 17;

          for (let l = 0; l < res.data.rvParksList.rvparks.length; l += csize) {
            rvListData.push(res.data.rvParksList.rvparks.slice(l, l + csize));
          }

          rvListData.forEach((rvData) => {
            const printMethod = count === 0 ? printPdfFull : printPdfPartial;
            printMethod(
              rvData,
              res.data.userMarket.address,
              "",
              "",
              "1",
              "RVParks List"
            );
          });
        }
        if (
          res.data.amenityAnalysis &&
          res.data.amenityAnalysis.pagination.totalrecords > 0
        ) {
          let amenitiesCount = Object.keys(
            res.data.amenityAnalysis.amenitypercentages
          ).length;
          amenitiesTableRow = [
            ...Array(
              Math.ceil(
                res.data.amenityAnalysis.amenities.length / amenitiesCount
              )
            ),
          ];
          amenitiesRows = amenitiesTableRow.map((row, idx) =>
            res.data.amenityAnalysis.amenities.slice(idx * totalAmenitiesCount, idx * totalAmenitiesCount + totalAmenitiesCount)
          );
          splittedArray = amenitiesRows
            .map((e, i) => {
              return i % 19 === 0 ? amenitiesRows.slice(i, i + 19) : null;
            })
            .filter((e) => {
              return e;
            });
          const amenitiesFirstHeader = [];
          let fSplit = 0,
            fRowSplit = 0;
          while (fRowSplit < amenitiesRows.length) {
            let inc = count;
            const csize =
              fRowSplit === 0
                ? inc > 19
                  ? inc - 19
                  : inc === 0
                    ? 19
                    : 19 - inc
                : 19;
            amenitiesFirstHeader.push(
              amenitiesRows.slice(fRowSplit, fRowSplit + csize)
            );
            fSplit = (fSplit + 1) % 2;
            fRowSplit += csize;
          }
          for (var j = 0; j < amenitiesFirstHeader.length; j++) {
            if (count === 0 || count > 17) {
              printPdfFull(
                amenitiesFirstHeader[j],
                res.data.userMarket.address,
                amenitiesData,
                "1",
                "2",
                "Amenity Analysis"
              );
            } else {
              printPdfPartial(
                amenitiesFirstHeader[j],
                res.data.userMarket.address,
                amenitiesData,
                "1",
                "2",
                "Amenity Analysis"
              );
            }
          }

          const amenitiesSecHeader = [];
          let secSplit = 0,
            secRowSplit = 0;
          while (secRowSplit < amenitiesRows.length) {
            let inc = count;
            const csize =
              secRowSplit === 0
                ? inc > 19
                  ? inc - 19
                  : inc === 0 || inc === 19
                    ? 19
                    : 19 - inc
                : 20;
            amenitiesSecHeader.push(
              amenitiesRows.slice(secRowSplit, secRowSplit + csize)
            );
            secSplit = (secSplit + 1) % 2;
            secRowSplit += csize;
          }
          for (var j = 0; j < amenitiesFirstHeader.length; j++) {
            if ((count === 0 || count > 10)) {
              printPdfFull(
                amenitiesFirstHeader[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "2",
                "Amenity Analysis"
              );
            } else {
              printPdfPartial(
                amenitiesFirstHeader[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "2",
                "Amenity Analysis"
              );
            }
          }
        }

        if (
          res.data.campingSpotClassifications.profileclasses &&
          res.data.campingSpotClassifications.profileclasses.length > 0
        ) {
          campSpotTableRow = [
            ...Array(
              Math.ceil(
                res.data.campingSpotClassifications.profileclasses.length / 15
              )
            ),
          ];
          campSpotRows = campSpotTableRow.map((row, idx) =>
            res.data.campingSpotClassifications.profileclasses.slice(
              idx * 15,
              idx * 15 + 15
            )
          );
          const restOfArrayCamp = [];
          let ccCamp = 0,
            k = 0;
          let inc = count;
          while (
            k < res.data.campingSpotClassifications.profileclasses.length
          ) {
            const csize =
              k === 0 ? (inc > 15 ? inc - 15 : inc === 0 || inc === 15 ? 15 : 15 - inc) : 15;
            restOfArrayCamp.push(
              res.data.campingSpotClassifications.profileclasses.slice(
                k,
                k + csize
              )
            );
            ccCamp = (ccCamp + 1) % 2;
            k += csize;
          }
          for (var j = 0; j < restOfArrayCamp.length; j++) {
            if (count === 0) {
              printPdfFull(
                restOfArrayCamp[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "3",
                "Camping Spot Classification"
              );
            } else {
              printPdfPartial(
                restOfArrayCamp[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "3",
                "Camping Spot Classification"
              );
            }
          }
        }

        if (
          res.data.pricingAnalysis.profileprices &&
          res.data.pricingAnalysis.profileprices.length > 0
        ) {
          const result = res.data.pricingAnalysis.profileprices.reduce(
            function (results, org) {
              (results[org.profilename+org.profileid] = results[org.profilename+org.profileid] || []).push(org);
              return results;
            },
            {}
          );
          profileArray.push(result);
          let filteredArray = Array.from(
            new Set(profileArray.map(JSON.stringify)),
            JSON.parse
          );
          priceAnalysis = filteredArray;
          let priceArray = [];
          for (var i = 0; i < Object.keys(priceAnalysis[0]).length; i++) {
            priceArray.push(Object.values(priceAnalysis[0])[i]);
          }
          let length = Object.keys(priceAnalysis[0]).length;
          pricingTableRow = [...Array(Math.ceil(length / 8))];

          pricigRows = pricingTableRow.map((row, idx) =>
            priceArray.slice(idx * 8, idx * 8 + 8)
          );
          const restOfArrayRvList = [];
          let ccList = 0,
            l = 0;
          let inc = count;
          while (l < priceArray.length) {
            let jumpCount = inc === 0 ? 6 : inc > 10 ? inc - 10 : 10 - inc;
            const csize = l === 0 ? (jumpCount === 0 || jumpCount > 5 ? 4 : jumpCount) : 4;
            restOfArrayRvList.push(priceArray.slice(l, l + csize));
            ccList = (ccList + 1) % 2;
            l += csize;
          }
          for (var j = 0; j < restOfArrayRvList.length; j++) {
            if (count === 0) {
              printPdfFull(
                restOfArrayRvList[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "4",
                "Pricing Analysis",
                res.data.pricingAnalysis.priceaverages
              );
            } else {
              printPdfPartial(
                restOfArrayRvList[j],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "4",
                "Pricing Analysis",
                res.data.pricingAnalysis.priceaverages
              );
            }
          }
        }

        if (
          res.data.seasonalityAnalysis.seasonaldata &&
          res.data.seasonalityAnalysis.seasonaldata.length > 0
        ) {
          seasonalityTableRow = [
            ...Array(
              Math.ceil(res.data.seasonalityAnalysis.seasonaldata.length / 19)
            ),
          ];
          seasonalityRows = seasonalityTableRow.map((row, idx) =>
            res.data.seasonalityAnalysis.seasonaldata.slice(
              idx * 19,
              idx * 19 + 19
            )
          );
          let graphData = res.data.seasonalityAnalysis.seasonalsummaries;

          if (count === 0) {
            printPdfFull(
              graphData,
              res.data.userMarket.address,
              amenitiesData,
              "1",
              "5",
              "Seasonality Analysis",
              ""
            );
          } else {
            printPdfPartial(
              graphData,
              res.data.userMarket.address,
              amenitiesData,
              "1",
              "5",
              "Seasonality Analysis",
              ""
            );
          }
          const restOfArraySes = [];
          let initial = 0,
            j = 0;
          while (j < res.data.seasonalityAnalysis.seasonaldata.length) {
            let inc = count;
            const csize =
              j === 0 ? (inc === 0 || inc === 17 || inc > 16 ? 17 : inc > 17 ? inc - 17 : 17 - inc) : 17;
            restOfArraySes.push(
              res.data.seasonalityAnalysis.seasonaldata.slice(j, j + csize)
            );
            initial = (initial + 1) % 2;
            j += csize;
          }
          for (var m = 0; m < restOfArraySes.length; m++) {
            if (count === 0) {
              printPdfFull(
                restOfArraySes[m],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "6",
                "Seasonality Analysis",
                ""
              );
            } else {
              printPdfPartial(
                restOfArraySes[m],
                res.data.userMarket.address,
                amenitiesData,
                "2",
                "6",
                "Seasonality Analysis",
                ""
              );
            }
          }
        }

        if (
          res.data.activityList &&
          res.data.activityList.activityanalysis &&
          res.data.activityList.activityanalysis.length > 0
        ) {
          const activityData = [];
          let ccList = 0,
            l = 0;
          let inc = count;
          while (l < res.data.activityList.activityanalysis.length) {
            const csize = 22;
            activityData.push(res.data.activityList.activityanalysis.slice(l, l + csize));
            ccList = (ccList + 1) % 2;
            l += csize;
          }
          for (var k = 0; k < activityData.length; k++) {
            if (count === 0) {
              printPdfFull(
                activityData[k],
                res.data.userMarket.address,
                "",
                res.data.activityList.keys,
                "8",
                "Activities/Attractions"
              );
            } else {
              printPdfPartial(
                activityData[k],
                res.data.userMarket.address,
                "",
                res.data.activityList.keys,
                "8",
                "Activities/Attractions"
              );
            }
          }
        }
        setReportData({
          ...reportData,
          amenitiesAnalysis: splittedArray,
          campingSpotClassifications: campSpotRows,
          pricingAnalysis: pricigRows,
          seasonalityAnalysis: seasonalityRows,
          marketAnalysis: res.data.marketAnalysis,
          userMarket: res.data.userMarket,
          marketPois: res.data.marketPois,
          rvParkList: res.data.rvParksList.rvparks,
          graphData: res.data.seasonalityAnalysis.seasonalsummaries,
          activities: res.data.activityList.activityanalysis,
          developmentState: developmentResult,
          transactionState: transData
        });
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  const genSingleSideHeading = () => {
    return (
      <Col sm={6} className="table-col">
        <div className="table-lists">
          <p>
            <span className="only-title">Interactive Map</span>{" "}
            <span className="only-value">1</span>
          </p>
          {reportData &&
            reportData.marketAnalysis &&
            reportData.marketAnalysis.summaryformarket ? (
            <p>
              <span className="only-title">Market Summary</span>{" "}
              <span className="only-value">2</span>
            </p>
          ) : (
            ""
          )}


          {reportData &&
            reportData.developmentState &&
            reportData.developmentState.length ? (
            <p>
              <span className="only-title">Development</span>{" "}
              <span className="only-value">{developPg}</span>
            </p>
          ) : (
            ""
          )}

          {reportData &&
            reportData.transactionState &&
            reportData.transactionState.length ? (
            <p>
              <span className="only-title">Transaction</span>{" "}
              <span className="only-value">{transactionPg}</span>
            </p>
          ) : (
            ""
          )}

          {reportData.rvParkList && reportData.rvParkList.length > 0 ? (
            <p>
              <span className="only-title">RVParks List </span>{" "}
              <span className="only-value">{rvListPg}</span>
            </p>
          ) : (
            ""
          )}
          {reportData.amenitiesAnalysis &&
            reportData.amenitiesAnalysis.length > 0 ? (
            <p>
              <span className="only-title">Amenity Analysis </span>{" "}
              <span className="only-value">{amenitiesPg}</span>
            </p>
          ) : (
            ""
          )}
          {reportData.campingSpotClassifications &&
            reportData.campingSpotClassifications.length > 0 ? (
            <p>
              <span className="only-title">Camping Spot Classification </span>{" "}
              <span className="only-value">{campSpotPg}</span>
            </p>
          ) : (
            ""
          )}
          {reportData.pricingAnalysis &&
            reportData.pricingAnalysis.length > 0 ? (
            <p>
              <span className="only-title">Pricing Analysis </span>{" "}
              <span className="only-value">{pricingPg}</span>
            </p>
          ) : (
            ""
          )}
          {reportData.seasonalityAnalysis &&
            reportData.seasonalityAnalysis.length > 0 ? (
            <p>
              <span className="only-title">Seasonality Analysis </span>{" "}
              <span className="only-value">{seasonalityPg}</span>
            </p>
          ) : (
            ""
          )}
          {reportData.activities &&
            reportData.activities.length > 0 ? (
            <p>
              <span className="only-title">Activities/Attractions </span>{" "}
              <span className="only-value">{activityPg}</span>
            </p>
          ) : (
            ""
          )}
        </div>
      </Col>
    );
  };
  return (
    <React.Fragment>
      <div className={!showUserLogo ? "print-pdf detail-pdf full-detail-pdf with_our_logo" : "print-pdf full-detail-pdf detail-pdf with_client_logo"}>
        <section className="pdf-wid-wrapper cover-page">
          <div className="cover-header">
            <img src={displayLogoRef.current} alt="RVParkIQ" className="client-logo" />
            <h1><span>Detailed</span><br /> Report</h1>
            <p>Produced on {moment(date).format("MMM DD YYYY")}</p>
          </div>

          <div className="cover-report-for">
            <h5>Report for: </h5>{" "}
            <React.Fragment>
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    reportData.userMarket &&
                      reportData.userMarket.address &&
                      reportData.userMarket.supplyradius
                      ? reportData.userMarket.supplyradius +
                      " miles around " +
                      reportData.userMarket.address
                      : "",
                }}
                className="market-title"
              />{" "}
            </React.Fragment>
          </div>
          <div className="cover-footer">
            <div className="contact-address">
              <h4>{companyInfo?.companyURL}</h4>
            </div>
          </div>
          <div id="pbreak" className="page-break" />
        </section>
        {/* table of contents */}
        <section className="pdf-wid-wrapper">
          <header className="page-header">
            <div className="page-logo">
              <a href="#">
                <img src={displayLogoRef.current} alt="RVParkIQ" />
              </a>
            </div>
            <div className="header-address">
              <p>
                {reportData.userMarket &&
                  reportData.userMarket.address &&
                  reportData.userMarket.address}
              </p>
            </div>
            <div className="clear"></div>
          </header>
          <div className="page-body">
            <Row className="m-0">
              <div className="table-content-only">
                <Col md={12} className="text-center">
                  <h3>
                    Table of Contents <span></span>
                  </h3>
                </Col>
                {genSingleSideHeading()}
              </div>
            </Row>
          </div>
          <footer className="page-footer">
            <div>
              This report is powered by data insights from {companyInfo?.companyName}. Visit <a href={companyInfo?.companyURL} target="_blank">{companyInfo?.companyURL}</a> © {(new Date().getFullYear())} {companyInfo?.companyName}.
            </div>
          </footer>
          <div id="pbreak" className="page-break" />
        </section>
        {reportData.userMarket &&
          reportData.userMarket.latitude &&
          reportData.userMarket.longitude ? (
          <section className="pdf-wid-wrapper">
            <header className="page-header">
              <div className="page-logo">
                <a href="#">
                  <img src={displayLogoRef.current} alt="RVParkIQ" />
                </a>
              </div>
              <div className="header-address">
                <p>
                  {reportData.userMarket &&
                    reportData.userMarket.address &&
                    reportData.userMarket.address}
                </p>
              </div>
              <div className="clear"></div>
            </header>
            <div className="page-number">Page No: 1</div>
            <div className="page-body">
              <h4 className="pdf-title">Map</h4>

              <PdfMap
                data={reportData.userMarket}
                marketPois={reportData.marketPois}
                address={
                  reportData.userMarket &&
                  reportData.userMarket.address &&
                  reportData.userMarket.address
                }
              />
            </div>
            <div id="pbreak" className="page-break" />
          </section>
        ) : (
          ""
        )}
        {/* market summary */}
        {reportData &&
          reportData.marketAnalysis &&
          reportData.marketAnalysis.summaryformarket ? (
          <section className="pdf-wid-wrapper">
            <header className="page-header">
              <div className="page-logo">
                <a href="#">
                  <img src={displayLogoRef.current} alt="RVParkIQ" />
                </a>
              </div>
              <div className="header-address">
                <p>
                  {reportData.userMarket &&
                    reportData.userMarket.address &&
                    reportData.userMarket.address}
                </p>
              </div>
              <div className="clear"></div>
            </header>
            <div className="page-number">Page No: 2</div>
            <div className="page-body">
              <h4 className="pdf-title">Market Summary</h4>

              <MarketSummaryPdf data={reportData.marketAnalysis} />
            </div>
            <div id="pbreak" className="page-break" />
          </section>
        ) : null}
        {elements}
      </div>
    </React.Fragment>
  );
});

export default DownloadDetailReport;
